var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"kt_aside",staticClass:"aside aside-left aside-fixed d-flex flex-column flex-row-auto aside-bg",attrs:{"id":"kt_aside"},on:{"mouseover":_vm.mouseEnter,"mouseleave":_vm.mouseLeave}},[_c('KTBrand')],1)}
var staticRenderFns = []

export { render, staticRenderFns }